import { api, publicApi } from "./api";

export const dictService = {
    getSubjects: params => api.get("/dicts/subjects/", { params }),
    getStudios: params => publicApi.get("/dicts/studios/", { params }),
    getGroups: params => api.get("/dicts/groups/", { params }),
    getEmployees: params => api.get("/school/employees/", { params }),
    getStudents: params => api.get("/school/students/", { params }),
    getParents: params => api.get("/school/parents", { params })
}
